import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
// @ts-expect-error Untyped import
import { LACKS_FIELD_ACCESS } from 'dashboard-lib/private/action-problem-solution/actions/view-report/problem';
import { jsx as _jsx } from "react/jsx-runtime";
export const DisabledReportLink = ({
  TooltipMessage,
  problem,
  reportName
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: TooltipMessage ? /*#__PURE__*/_jsx(TooltipMessage, {}) : null,
  use: problem === LACKS_FIELD_ACCESS.toString() ? 'longform' : 'default',
  children: /*#__PURE__*/_jsx(Link, {
    disabled: true,
    children: /*#__PURE__*/_jsx("div", {
      "data-test-report-name": reportName,
      children: /*#__PURE__*/_jsx(TruncateString, {
        tooltip: false,
        children: reportName
      })
    })
  })
});